import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';
import { Chart } from '../Charts/ChartWrapper';
import { backgroundPlugin, progressBackgroundPlugin, CenterBarLabelsPlugin } from "../Charts/gradientHelper";
import { ApplyFormatterFunction } from '../Charts/formatters';



export default function SnippetChartReport() {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [snippetBaseStats, setSnippetBaseStats] = useState(undefined)
    const [chartMetadata, setChartMetadata] = useState(undefined)

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetBaseStats(undefined)
        setChartMetadata(undefined)
        setSnippetInfo(undefined)
        getSnippetBaseStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetBaseStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/base/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      setSnippetBaseStats(data)


    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}?allInfo=true`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)

      const chartMetadata = JSON.parse(data.snippetSettings)
        //if the series had gradients applied then backgroundColor will be undefined
        //since it was a gradient function that gets lost during serialization
        //in this case we'll set it with the gradient colors again
        for (const ds of chartMetadata.data.datasets) {
          if (ds.backgroundColor == undefined) ds.backgroundColor = ds.gradientColors
        }
        //similarly we need to re-attach the plugins
        ApplyFormatterFunction(chartMetadata)
        //console.log(chartMetadata)
        chartMetadata.plugins = [progressBackgroundPlugin, backgroundPlugin, CenterBarLabelsPlugin]

      console.log(chartMetadata)
      setChartMetadata(chartMetadata)
  

    } catch (error) {
      console.log(error);
    }
  }

    return <div>
            <CcTitle>Element Report Chart</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Total Views', value: snippetBaseStats ? snippetBaseStats.totalOpens : undefined },
                                    {title: 'Total Clicks', value: snippetBaseStats ? snippetBaseStats.totalClicks : undefined},
                                    {title: 'Chart Type', value: chartMetadata ? chartMetadata.selectedChartId : undefined},
                                    ]} />
            </div>
            <div className='mt-6 bg-slate-200 rounded p-4 w-fit'>
                {chartMetadata &&
                  <div className='w-[800px] overflow-auto'><Chart metadata={chartMetadata} /></div>
                }
            </div>
    </div>
}